(function () {


	angular.module('app.widgets')
	.directive('plaActionModal', plaActionModal); 

	function plaActionModal() {
        return {
            restrict: 'E',
            templateUrl: 'app/widgets/actionModal.html',
            scope: {
                itemId: '@',
                titulo: '@',
                detalle: '@',
                accionAceptarCallback: '&'
            },
            controllerAs: 'vm',
            controller: function($scope){
                var vm = this;
                vm.itemId = $scope.itemId;
                vm.titulo = $scope.titulo;
                vm.detalle = $scope.detalle;

                vm.aceptar = function(){
                    $scope.accionAceptarCallback();
                };

            }
        }
    }

})();